import { AuthEnums } from "models/enums";
import { ExportedFilesFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import useAPIClientHelper from "./useAPIClientHelper";
import { FileHelper, LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModelExportItems, WintUtilsWebApi } from "wint-api-client/dist/types";

function useExportItemService() {
  const { apiClientInstance } = useAPIClientHelper();

  const filter = (filter: WintSuperkollAPIModelExportItems.ExportItemFilter) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).ExportItemsClient.Get(filter);
  };

  const reportFilter = (baseFilter: WintUtilsWebApi.Filter, formFilter?: ExportedFilesFormTypes.ExportItemsFilter) => {
    return filter({
      ...baseFilter,
      ...reportToAPIFilter(formFilter),
    });
  };

  const reportToAPIFilter = (
    formFilter?: ExportedFilesFormTypes.ExportItemsFilter
  ): Omit<WintSuperkollAPIModelExportItems.ExportItemFilter, keyof WintUtilsWebApi.Filter> => {
    return {
      onlyMine: formFilter?.onlyMine,
      startDate: formFilter?.dateRange?.start,
      endDate: formFilter?.dateRange?.end,
      state: formFilter?.state !== undefined ? formFilter?.state : undefined,
    };
  };

  const downloadExportedFile = (id: number) => {
    apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    })
      .ExportItemsClient.Download(id)
      .then((res) => {
        FileHelper.download(res);
      });
  };

  const getStateText = (status?: WintSuperkollAPIModelExportItems.ExportItemState | number) => {
    switch (status) {
      case WintSuperkollAPIModelExportItems.ExportItemState.Processing:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Processing);
      case WintSuperkollAPIModelExportItems.ExportItemState.Done:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Done);
      case WintSuperkollAPIModelExportItems.ExportItemState.Error:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Error);

      default:
        return " ";
    }
  };

  return {
    filter,
    reportFilter,
    reportToAPIFilter,
    downloadExportedFile,
    getStateText,
  };
}

export default useExportItemService;
